import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext';
import AdminDashboard from './components/admin/AdminDashboard';
import ApiSessionBanner from './components/common/ApiSessionBanner';

function App() {
  return (
    <Router>
      <ToastProvider>
      <div className="min-h-screen bg-gradient-to-b from-slate-100/90 via-slate-50 to-slate-100">
        <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
          <ApiSessionBanner />
          <Routes>
            {/* <Route path="/user" element={<UserDashboard />} />
            <Route path="/admin" element={<AdminDashboard />} /> */}
            <Route path="/" element={<AdminDashboard />} />
          </Routes>
        </main>
      </div>
      </ToastProvider>
    </Router>
  );
}

export default App;
